import {
	BaseDataItem,
	Data,
	PresetData,
	PresetsDataMap,
	UnresolvedPresetsDataItem,
	UnresolvedRefArray,
	ResolvedPresetsRefArray,
} from '@wix/thunderbolt-becky-types'
import { REF_DELIMITER, removeHash } from './utils'

const getPresetsFromRefArray = (presetsRefArray: UnresolvedRefArray, presetsDataMap: PresetsDataMap) =>
	presetsRefArray.values.map((itemId) => {
		const resolvedItem = presetsDataMap[removeHash(itemId)]
		return resolvedItem.type === 'VariantRelation'
			? { ...resolvedItem, to: presetsDataMap[removeHash(resolvedItem.to)] }
			: resolvedItem
	})

export const getPresets = (
	presets: Array<UnresolvedPresetsDataItem>,
	presetsDataMap: PresetsDataMap
): Array<ResolvedPresetsRefArray['values']> =>
	presets.map((preset) => {
		if (!preset) {
			return []
		}
		if (preset.type === 'RefArray') {
			return getPresetsFromRefArray(preset, presetsDataMap) as ResolvedPresetsRefArray['values']
		}
		return [preset as PresetData]
	})

export const shouldInflateRefArray = (dataItem: BaseDataItem<string>, mapName: keyof Data) => {
	const isLayoutOrStyle = mapName === 'layout_data' || mapName === 'theme_data'
	const isRefArray = dataItem.type === 'RefArray'

	return isLayoutOrStyle && isRefArray
}

// "ref1_r_ref2 => ["ref1", "ref1_r_ref2"]
export const getRefCompIds = (refCompId: string) => {
	const res: Array<string> = []
	refCompId.split(REF_DELIMITER).forEach((refId, index) => {
		if (index > 0) {
			res.push(`${res[index - 1]}${REF_DELIMITER}${refId}`)
		} else {
			res.push(refId)
		}
	})
	return res
}
